// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_42r","cls2":"DownloadOptionCard-cls2_TAt DownloadOptionCard-cls1_42r","layout-half":"DownloadOptionCard-layout-half_65v"};